import { render, staticRenderFns } from "./ProxyPage.vue?vue&type=template&id=5beff69c&scoped=true"
import script from "./ProxyPage.vue?vue&type=script&lang=js"
export * from "./ProxyPage.vue?vue&type=script&lang=js"
import style0 from "./ProxyPage.vue?vue&type=style&index=0&id=5beff69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beff69c",
  null
  
)

export default component.exports